import { useEffect, useState } from 'react';

function debounce(fn, ms) {
    let timer
    return _ => {
      clearTimeout(timer)
      timer = setTimeout(_ => {
        timer = null
        fn.apply(this, arguments)
      }, ms)
    };
  }

const useWindowSize = (enabled = true) => {
    const isClient = typeof window === 'object';
  
    function getSize() {
      return {
        width: isClient ? window.innerWidth : undefined,
        height: isClient ? window.innerHeight : undefined
      };
    }
  
    const [windowSize, setWindowSize] = useState(getSize);
  
    useEffect(() => {
      if (!isClient || !enabled) {
        return;
      }
      
      const debouncedHandleResize = debounce(function handleResize() {
        setWindowSize(getSize());
      }, 300)
  
      window.addEventListener('resize', debouncedHandleResize);
      return () => window.removeEventListener('resize', debouncedHandleResize);
    }, [enabled, getSize, isClient]);
  
    return windowSize;
  };

  export default useWindowSize;
